import { GetInferredFromRaw } from '@thinknimble/tn-models'
import { z } from 'zod'
import { baseModelShape } from '../base-model'

export const eventTypeEnum = {
  JOB_COMPLETED: 'job_completed',
  JOB_FAILED: 'job_failed',
} as const

export type EventTypeValues = (typeof eventTypeEnum)[keyof typeof eventTypeEnum]

export const notificationShape = {
  ...baseModelShape,
  eventType: z.string(),
  title: z.string(),
  body: z.string(),
  metadata: z.record(z.string(), z.any()).optional(),
  isRead: z.boolean(),
}

export const notificationFilterShape = {
  isRead: z.boolean(),
  eventType: z.string(),
}

export type Notification = GetInferredFromRaw<typeof notificationShape>
export type NotificationFilter = GetInferredFromRaw<typeof notificationFilterShape>
